import { render, staticRenderFns } from "./chargeBlockNew.vue?vue&type=template&id=058c3ca7&"
import script from "./chargeBlockNew.vue?vue&type=script&lang=js&"
export * from "./chargeBlockNew.vue?vue&type=script&lang=js&"
import style0 from "./chargeBlockNew.vue?vue&type=style&index=0&id=058c3ca7&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports